import i18next from "i18next";
import { useTranslation } from "react-i18next";
import numeral from 'numeral';
import wsclients from "../services/wsclients";
import moment from 'moment';
import { configData } from "../config/main.config";

export function isRetina(first, second) {
    if (window.devicePixelRatio >= 2) {
        return second
    }
    return first;
};
export function newGUID() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return s4() + s4() + s4() + s4() +
        s4() + s4() + s4() + s4();
}

export function sortByDesc(n1, n2) {
    if (n1.description < n2.description)
        return 1;
    if (n1.description > n2.description)
        return -1;
    if (n1.description == n2.description)
        return 0;
};

export function readMWCode(code, t) {
    
    switch (code) {
        case 'EXCEPTION':
            return t('EXCEPTION') + '(0)';
        case 'INVALID_LOGIN':
            return t('INVALID_LOGIN');
        case 'USER_ACCOUNT_NOT_VERIFIED':
            return t('USER_ACCOUNT_NOT_VERIFIED');
        case 'INVALID_VERIFICATION_CODE':
            return t('INVALID_VERIFICATION_CODE');
        case 'INVALID_VERFICATION_TOKEN':
            return t('INVALID_VERFICATION_TOKEN');
        case 'INVALID_TOKEN':
            return t('INVALID_TOKEN');
        case 'INVALID_INPUT':
            return t('INVALID_INPUT');
        case 'ACCOUNT_EXISTS_ALREADY':
            return t('ACCOUNT_EXISTS_ALREADY');
        case 'CRM_GET_TOKEN_FAIL':
            return t('CRM_GET_TOKEN_FAIL');
        case 'SCHEMA_VALIDATION_FAILED':
            return t('SCHEMA_VALIDATION_FAILED');
        case 'REFERRING_PARTICIPANT_NOT_FOUND':
            return t('REFERRING_PARTICIPANT_NOT_FOUND');
        case 'PARTICIPANT_NOT_FOUND':
            return t('PARTICIPANT_NOT_FOUND');
        case 'INVALID_TRANSFER_CARD_INFO':
            return t('INVALID_TRANSFER_CARD_INFO')
        case 'OBJECT_NOT_FOUND':
            return t('OBJECT_NOT_FOUND');
        case 'SERVER_UNEXPECTED_ISSUE':
            return t('EXCEPTION') + '(1)';
        case 'NETWORK_ISSUE':
            return t('NETWORK_ISSUE');
        case 'CLIENT_UNEXPECTED_ISSUE':
            return t('EXCEPTION') + '(2)';
        case 'CARD_BEING_TRANSFERED_NOT_FOUND':
            return t('CARD_BEING_TRANSFERED_NOT_FOUND');
        case 'CHANGE_PASSWORD_FAILED':
            return t('CHANGE_PASSWORD_FAILED');
        case 'PHONE_TOKEN_EXISTS_AND_BELONG_TO_ANOTHER':
            return t('profile_existed_phone');
        case 'CREATE_ACHIEVEMENTS_ERROR':
            return t('CREATE_ACHIEVEMENTS_ERROR');
        case 'TOKEN_EXPIRED':
            return t('TOKEN_EXPIRED');
        case 'EMAIL_NOT_FOUND_EXCEPTION':
            return t('EMAIL_NOT_FOUND_EXCEPTION');
        case 'PHONE_NOT_FOUND_EXCEPTION':
            return t('PHONE_NOT_FOUND_EXCEPTION');
        case 'POSTAL_CODE_DOES_NOT_MATCH':
            return t('POSTAL_CODE_DOES_NOT_MATCH');
        case 'FAILED_TO_UPDATE_ADDRESS':
            return t('FAILED_TO_UPDATE_ADDRESS');
        case 'FAILED_TO_REMOVE_ADDRESS':
            return t('FAILED_TO_REMOVE_ADDRESS');
        case 'MAX_ADDRESSES_REACHED':
            return t('MAX_ADDRESSES_REACHED');
        case 'FAILED_TO_MODIFY_PHONE':
            return t('FAILED_TO_MODIFY_PHONE');
        case 'FAILED_TO_UPDATE_TOKEN_PHONE':
            return t('FAILED_TO_UPDATE_TOKEN_PHONE');
        case 'MAX_PHONES_REACHED':
            return t('MAX_PHONES_REACHED');
        case 'FAILED_TO_UPDATE_CONSENT':
            return t('FAILED_TO_UPDATE_CONSENT');
        case 'FAILED_TO_UPDATE_LANGUAGE':
            return t('FAILED_TO_UPDATE_LANGUAGE');
        case 'FAILED_TO_PURCHASE_VOUCHER':
            return t('FAILED_TO_PURCHASE_VOUCHER');
        case 'REFERENCE_CODE_UNIQUE':
            return t('REFERENCE_CODE_UNIQUE');
        case 'REFERENCE_CODE_EMPTY':
            return t('REFERENCE_CODE_EMPTY');
        case 'REFERENCE_CODE_INVALID':
            return t('REFERENCE_CODE_INVALID');
        case 'AMOUNT_INVALID':
            return t('AMOUNT_INVALID');
        case 'FAILED_TO_DEBIT_WALLET_FOR_GIFT_EVOUCHER_PURCHASE_BALANCE_NOT_ENOUGH':
            return t('wallet_for_gift_not_enough');
        case 'FAILED_TO_DEBIT_WALLET_FOR_GIFT_EVOUCHER_PURCHASE':
            return t('FAILED_TO_PURCHASE_EVOUCHER');
        case 'INVALID_PASSWORD':
            return t('INVALID_PASSWORD');
        case 'FAILED_TO_CREATE_TOPUP':
            return t('FAILED_TO_CREATE_TOPUP');
        case 'FAILED_TO_RELEASE_PUMP_UNKNOWN':
            return t('FAILED_TO_RELEASE_PUMP_UNKNOWN');
        case 'FAILED_TO_RELEASE_PUMP_BUSY':
            return t('FAILED_TO_RELEASE_PUMP_BUSY');
        case 'FAILED_TO_RELEASE_PUMP_TIMEOUT':
            return t('FAILED_TO_RELEASE_PUMP_TIMEOUT');
        case 'FAILED_TO_RELEASE_PUMP_REJECTED':
            return t('FAILED_TO_RELEASE_PUMP_REJECTED');
        case 'INVALID_PASSCODE_LENGTH':
            return t('INVALID_PASSCODE_LENGTH');
        case 'INVALID_PASSCODE_CHARACTER':
            return t('INVALID_PASSCODE_CHARACTER');
        case 'RECIPIENT_PHONE_NOT_FOUND_EXCEPTION':
            return t('RECIPIENT_PHONE_NOT_FOUND_EXCEPTION');
        case 'MANY_ACCOUNT_EXCEPTION':
            return t('MANY_ACCOUNT_EXCEPTION');
        case 'ACCOUNT_NOT_ACTIVE_EXCEPTION':
            return t('ACCOUNT_NOT_ACTIVE_EXCEPTION');
        case 'FAILED_TO_TRANSFER_SMILES':
            return t('FAILED_TO_TRANSFER_SMILES');
        case 'SEND_PHONE_NOT_FOUND':
            return t('SEND_PHONE_NOT_FOUND');
        case 'RECEIVE_PHONE_NOT_FOUND':
            return t('RECEIVE_EMAIL_NOT_FOUND');
        case 'TRANSFER_SMILES_PHONE_NOT_FOUND':
            return t('TRANSFER_SMILES_PHONE_NOT_FOUND');
        case 'FAILED_TO_SETTING_CARD_NOT_FOUND':
            return t('FAILED_TO_SETTING_CARD_NOT_FOUND');
        case 'FAILED_TO_RELEASE_PUMP_LOCATION_INCORECT':
            return t('current_location_not_same')
        case 'FAILED_TO_SET_DEFAULT_CARD':
            return t('FAILED_TO_SET_DEFAULT_CARD')
        case 'FAILED_TO_RELEASE_PUMP':
            return t('FAILED_TO_RELEASE_PUMP')
        default:
            return t('EXCEPTION') + '(3)';
    }
}
export function createEntityImage(prodID) {
    return "entity=product&entity_id=" + prodID;
}export function formatDateToObject(date, isFullDate) {
    var date = new Date(date);
    var day = date.getDate();
    var month = date.getMonth();
    if (day < 10) day = '0' + day;
    //if (month < 10) month = '0' + month;
    var months = createShortMonth();
    month = months[month];
    if (isFullDate) {
        return day + " " + month + " " + date.getFullYear();
    }
    return { day: day, month: month, year: date.getFullYear() }
}

export function createShortMonth() {
    var month =  i18next.t('SHORTMONTH',{ returnObjects: true});
    let months = [
        month.JAN,
        month.FEB,
        month.MAR,
        month.APR,
        month.MAY,
        month.JUN,
        month.JUL,
        month.AUG,
        month.SEP,
        month.OCT,
        month.NOV,
        month.DEC,
    ];

    return months;
}

export function getFirstLetter(string) {
    if (string) {
        var matches = string.match(/\b(\w)/g);
        if (matches) {
            var newStr = matches.join('');
            return newStr;
        }else{
            return ""
        }
    }
    return ""
}

export function renderTextCode(string) {
    if (string) {
        return string.toLowerCase().replace(' ', '_');
    }
    return ""
}

export function getMonthsFromCurrentDate() {
    var newMonths = [];
    var months = createMonthsFromCurrentDate();
    for (var i = 0; i < months.length; i++) {
        var month = new Date(months[i]);
        var year = month.getFullYear().toString();
        newMonths.push(month.getMonth() + "/" + year.substring(year.length - 2, year.length));
    }
    return newMonths;
}
export function createMonthsFromCurrentDate() {
    var currentMonth = new Date().getMonth() + 1;
    var months = [];
    for (var i = 0; i < 12; i++) {
        var previousMonth = currentMonth - i;
        var previoustDate = new Date(new Date().getFullYear(), previousMonth, new Date().getDate());
        months.push(previoustDate);
    }
    months = months.sort(sortDate);
    return months;
}

function sortDate(a, b) {
    if (a < b) {
        return -1;
    } else if (a > b) {
        return 1;
    } else
        return 0
}

export function formatFloat(value) {
    if (!value)
        return '';
    if (value == '')
        return;
    let val = value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    return val;
}

export function parseFloat(value) {
    if (!value)
        return '';
    if (value == '')
        return;
    let val = value.toString().replace(/,/g, '');
    //val = val.toString().match(/\d*\.?\d{0,2}/);
    val = val.toString().match(/\d*\.?\d*/);
    //val = numeral(val[0]).format('0.00');
    val = val[0];
    //console.log('Parse Float: ' + value + ' to ' + val);
    return val;
}

export function parseAPIFloat(value) {
    if (!value)
        return '';
    if (value == '')
        return;
    let val = value.toString().replace(/,/g, '');
    val = val.toString().match(/\d*\.?\d{0,2}/);
    val = numeral(val[0]).format('0.00');
   // console.log('Parse Float for API: ' + value + ' to ' + val);
    return val;
}

export function formatDateToObjectWithTime(date, isFullDate) {
    var date = new Date(date);
    var day = date.getDate();
    var month = date.getMonth();
    if (day < 10) day = '0' + day;
    var months = createShortMonth();
    month = months[month];
    var hours = date.getHours()
    var minutes = date.getMinutes();
    var second = date.getSeconds();
    if (hours < 10) hours = '0' + hours;
    if (minutes < 10) minutes = '0' + minutes;
    if (second < 10) second = '0' + second;
    var time = hours + ":" + minutes + ":" + second;
    if (isFullDate) {
        return day + " " + month + " " + date.getFullYear() + " - " + time;
    }
    return { day: day, month: month, year: date.getFullYear() }
}

export function formatDateTime(dateTime) {
    var date = new Date(dateTime);
    var day = date.getDate();
    var month = date.getMonth() + 1;
    var hours = date.getHours()
    var minutes = date.getMinutes();
    var second = date.getSeconds();

    if (day < 10) day = '0' + day;
    if (month < 10) month = '0' + month;
    if (hours < 10) hours = '0' + hours;
    if (minutes < 10) minutes = '0' + minutes;
    if (second < 10) second = '0' + second;
    var time = hours + ":" + minutes + ":" + second;
    var dateFormatted = day + '/' + month + '/' + date.getFullYear() + " " + time;

    return dateFormatted;
}


export function checkValidDateOfBirth(date_of_birth) {
    const { day, month, year } = date_of_birth;
    if (!day || !month || !year) return true;
    var intDay = Number.parseInt(day);
    var intMonth = Number.parseInt(month);
    var intYear = Number.parseInt(year);
    if (intMonth === 2) {
        if (intYear % 4 === 0) {
            if (intDay < 30) return true;
            else return false;
        } else {
            if (intDay < 29) return true;
            else return false;
        }
    }
    if ([1, 3, 5, 7, 8, 10, 12].includes(intMonth)) {
        if (intDay < 32) return true;
        else return false;
    } else {
        if (intDay < 31) return true;
        else return false;
    }
}


export function checkEnoughAge(date_of_birth) {
    var birthday = new Date(date_of_birth.year, date_of_birth.month, date_of_birth.day);
    var current = Date.now();
    var yearOldMili = current - birthday;
    var yearOld = yearOldMili / (1000 * 3600 * 24 * 365);

    return (yearOld < 18)
        ? false
        : true;
}

export function sortByPrice(n1, n2) {
    if (n1.price > n2.price)
        return 1;
    if (n1.price < n2.price)
        return -1;
    if (n1.price == n2.price)
        return 0;
};

export function sortByOrderField(n1, n2) {
    if (n1.order > n2.order)
        return 1;
    if (n1.order < n2.order)
        return -1;
    if (n1.order == n2.order)
        return 0;
};

export function capitalize(string){
    if(string){
        string = string.toLowerCase();
        let split = string.split(' ');
        if(split.length > 1){
            let newS  = [];
            split.forEach(s => {
                if(s[0]){ 
                    newS.push(s[0].toUpperCase() + s.slice(1))
                }
            });
            return newS.join(' ');
        }else{
            return string[0].toUpperCase() + string.slice(1);
        }
    }
    return '';
}

//note: old portal use function
export function verify_id_number(id_number, gender = '', foreigner = 0){
    let valid = false;
    if(!isNaN(id_number) && id_number.length === 13){
        let error = false;
        let num_array = id_number.split("");
        let id_month = num_array[2] + "" + num_array[3];
        let id_day = num_array[4] + "" + num_array[5];
        if(parseInt(id_month) < 1 || parseInt(id_month) > 12) error=  true;
        if(parseInt(id_day) < 1 || parseInt(id_day) > 31) error = true;

        //validate gender
        let id_gender = num_array[6] >= 5 ? 'male' : 'female';
        if(gender && gender.toLowerCase() !== id_gender) error = true;

        //validate citizenship
        let id_foreigner = num_array[10];
        if((foreigner || id_foreigner) && (parseInt(foreigner) !== parseInt(id_foreigner))) error = true;
        
        //Check Digit Verification
        let even_digits = [];
        let odd_digits = [];
        for (let index = 0; index < num_array.length; index++) {
            const item = num_array[index];
            if(index === 0 || index % 2 === 0) odd_digits.push(item);
            else even_digits.push(item);
            
        }
        // use array pop to remove the last digit from $odd_digits and store it in check_digit
        //lấy ra phần tử cuối cùng
        let check_digit = odd_digits.pop();
        console.log("check_digit==", check_digit);

        //All digits in odd positions (excluding the check digit) must be added together.
        //tính tổng các số trong array
        let added_odds = odd_digits.reduce(add, 0);

        //All digits in even positions must be concatenated to form a 6 digit number.
        //nối thành chuỗi
        let concatenated_evens = even_digits.join("");

        //This 6 digit number must then be multiplied by 2.
        //parse sang số rồi nhân 2
        let evensx2 = parseInt(concatenated_evens)*2;

        // Add all the numbers produced from the even numbers x 2
        //evensx2 chuyển thành chuỗi rồi cắt và tính tổng các phần tử 
        let added_evens = ((evensx2 + "").split("")).reduce(add, 0);

        //cộng tổng rồi biến thành chuỗi
        let sum = (added_odds + added_evens) + "";

        // get the last digit of the sum
        //get phần tử cuối
        let last_digit = sum.substr(sum.length-1, sum.length);
        /* 10 - $last_digit
        * $verify_check_digit = 10 - (int)$last_digit; (Will break if $last_digit = 0)
        * Edit suggested by Ruan Luies
        * verify check digit is the resulting remainder of
        *  10 minus the last digit divided by 10
        */
       let verify_check_digit = (10 - parseInt(last_digit)) % 10;
       console.log("verify_check_digit==", verify_check_digit);

       // test expected last digit against the last digit in $id_number submitted
       if (parseInt(verify_check_digit) !== parseInt(check_digit)) error = true;
       console.log("error===", error);

       // if errors haven't been set to true by any one of the checks, we can change verified to true;
       if (!error) valid = true;
    }
    console.log("valid===", valid);
    return valid;
}

function add(accumulator, a) {
    return parseInt(accumulator) + parseInt(a);
}

export function onValidateIdNumber(value){
    let valid = true;
    //length = 13
    //ký tự đầu tiên số bất kỳ từ 0-9
    //{2} trùng với ký tự đầu tiên
    //(0[13578]|1[02]): 
        //1. ký tự thứ 3 nếu là 0 thì ký tự thứ 4 sẽ phải là 1,3,5,7,8 
        //2. hoặc nếu là 1 thì phải là 0,2
    //(0[1-9]|[12]\d|3[01]): 
        //1. ký tự thứ 5 nếu là 0 thì ký tự thứ 6 từ 1-9, 
        //2. hoặc ký tự thứ 5 là 1,2, thì ký tự 6 phải trong tập hợp ký tự số, 
        //3. hoặc là 3 thì ký tự thứ 6 sẽ là 0,1
    //(0[13456789]|1[012]):
        //1. ký tự thứ 7 là 0 thì ký tự thứ 8 phải là 1,3,4,5,6,7,8,9
        //2. hoặc ký tự thứ 7 là 1 thì ký tự thứ 8 là 0,1,2
    //(0[1-9]|[12]\d|30):
        //1. ký tự thứ 9 là 0 thì ký tự thứ 10 từ 1-9
        //2. hoặc ký tự 9 là 1,2 thì ký tự thứ 10 thuộc tập chứ số
        //3. hoặc ký tự thứ 9 là 3, thứ 10 là 0
    //02(0[1-9]:
    //1\d:
    //2[0-8]:

    //([02468][048]|[13579][26])0229))

    //(( |-)(\d{4})( |-)(\d{3})|(\d{7}))
    var ex = /^(((\d{2}((0[13578]|1[02])(0[1-9]|[12]\d|3[01])|(0[13456789]|1[012])(0[1-9]|[12]\d|30)|02(0[1-9]|1\d|2[0-8])))|([02468][048]|[13579][26])0229))(( |-)(\d{4})( |-)(\d{3})|(\d{7}))/;
    if (ex.test(value) === false) {
        return false;
    }
    return valid;
}

export const getPeriodDate = (period) => {
	let date = null

	if(period)
	{
		switch (period.toUpperCase()) {
			case dateRangePeriod.START_OF_TODAY:
				date = moment().hour(0).minute(0).second(0).toDate();
				break;
			case dateRangePeriod.END_OF_TODAY:
				date = moment().hour(23).minute(59).second(59).toDate();
				break;
			case dateRangePeriod.START_OF_YESTERDAY:
				date = moment().add(-1, 'day').hour(0).minute(0).second(0).toDate();
				break;
			case dateRangePeriod.END_OF_YESTERDAY:
				date = moment().add(-1, 'day').hour(23).minute(59).second(59).toDate();
				break;
			case dateRangePeriod.START_OF_TOMORROW:
				date = moment().add(1, 'day').hour(0).minute(0).second(0).toDate();
				break;
			case dateRangePeriod.END_OF_TOMORROW:
				date = moment().add(1, 'day').hour(23).minute(59).second(59).toDate();
				break;
			case dateRangePeriod.START_OF_THIS_WEEK:
				date = moment().startOf('week').hour(0).minute(0).second(0).toDate();
				break;
			case dateRangePeriod.END_OF_THIS_WEEK:
				date = moment().endOf('week').hour(23).minute(59).second(59).toDate();
				break;
			case dateRangePeriod.START_OF_THIS_MONTH:
				date = moment().startOf('month').hour(0).second(0).minute(0).toDate();
				break;
			case dateRangePeriod.END_OF_THIS_MONTH:
				date = moment().endOf('month').hour(23).minute(59).second(59).toDate();
				break;
			case dateRangePeriod.START_OF_THIS_YEAR:
				date = moment().startOf('year').hour(0).minute(0).second(0).toDate();
				break;
			case dateRangePeriod.END_OF_THIS_YEAR:
				date = moment().endOf('year').hour(23).minute(59).second(59).toDate();
				break;
			case dateRangePeriod.START_OF_THIS_HOUR:
				date = moment().minute(0).second(0).toDate();
				break;
			case dateRangePeriod.END_OF_THIS_HOUR:
				date = moment().minute(59).second(59).toDate();
				break;
			case dateRangePeriod.START_OF_LAST_WEEK:
				date = moment().add(-1, 'week').startOf('week').hour(0).minute(0).second(0).toDate();
				break;
			case dateRangePeriod.END_OF_LAST_WEEK:
				date = moment().add(-1, 'week').endOf('week').hour(23).minute(59).second(59).toDate();
				break;
			case dateRangePeriod.START_OF_LAST_MONTH:
				date = moment().add(-1, 'month').startOf('month').hour(0).minute(0).second(0).toDate();
				break;
			case dateRangePeriod.END_OF_LAST_MONTH:
				date = moment().add(-1, 'month').endOf('month').hour(23).minute(59).second(59).toDate();
				break;
			case dateRangePeriod.START_OF_NEXT_WEEK:
				date = moment().add(1, 'week').startOf('week').hour(0).minute(0).second(0).toDate();
				break;
			case dateRangePeriod.END_OF_NEXT_WEEK:
				date = moment().add(1, 'week').endOf('week').hour(23).minute(59).second(59).toDate();
				break;
			case dateRangePeriod.START_OF_NEXT_MONTH:
				date = moment().add(1, 'month').startOf('month').hour(0).minute(0).second(0).toDate();
				break;
			case dateRangePeriod.END_OF_NEXT_MONTH:
				date = moment().add(1, 'month').endOf('month').hour(23).minute(59).second(59).toDate();
				break;
			case dateRangePeriod.START_OF_FIVE_MONTHS_AGO:
				date = moment().add(-5, 'month').startOf('month').hour(0).minute(0).second(0).toDate();
				break;
			case dateRangePeriod.START_OF_LAST_YEAR:
				date = moment().add(-1, 'year').startOf('year').hour(0).minute(0).second(0).toDate();
				break;
			case dateRangePeriod.END_OF_LAST_YEAR:
				date = moment().add(-1, 'year').endOf('year').hour(23).minute(59).second(59).toDate();
				break;
			default:
				break;
		}
	}

	return date;
}

export const formatPeriodDate = (date) => {
    return Math.floor(date.getTime() / 1000.0);
}

export const dateRangePeriod = {
	START_OF_TODAY: 'START_OF_TODAY',
	END_OF_TODAY: 'END_OF_TODAY',
	START_OF_THIS_MONTH: 'START_OF_THIS_MONTH',
	END_OF_THIS_MONTH: 'END_OF_THIS_MONTH',
	START_OF_THIS_YEAR: 'START_OF_THIS_YEAR',
	END_OF_THIS_YEAR: 'END_OF_THIS_YEAR',
	START_OF_LAST_MONTH: 'START_OF_LAST_MONTH',
	END_OF_LAST_MONTH: 'END_OF_LAST_MONTH',
	START_OF_LAST_YEAR: 'START_OF_LAST_YEAR',
	END_OF_LAST_YEAR: 'END_OF_LAST_YEAR'
}

export const statementPeriodOption = {
	THIS_MONTH: "THIS_MONTH",
	LAST_MONTH: "LAST_MONTH",
	THIS_YEAR: "THIS_YEAR",
	LAST_YEAR: "LAST_YEAR",
	SPECIFIC_PERIOD:  "SPECIFIC_PERIOD"
}

export function formatDateToMMYYYY(date) {
    var date = new Date(date);
    var month = date.getMonth() + 1;
    if (month < 10) month = '0' + month;
    var dateFormatted = month + '/' + date.getFullYear();
    return dateFormatted;
}

export function formatDateToDDMMYYYY(date) {
    var date = new Date(date);
    var day = date.getDate();
    var month = date.getMonth() + 1;
    if (day < 10) day = '0' + day;
    if (month < 10) month = '0' + month;
    var dateFormatted = day + '/' + month + '/' + date.getFullYear();
    return dateFormatted;
}

export function formatDateToDDMMYYYYFrEpoch(epochTime,normal) {
    var d = new Date(epochTime * 1000); // The 0 there is the key, which sets the date to the epoch
    return normal ? formatDateToDDMMYYYY(d) : formatDateToMonthNameAndDayOfWeek(d);;
}

export function formatDateToMonthNameAndDayOfWeek(date) {
    var date = new Date(date);
    var dayOfWeeks = createShortDayOfWeek();
    var dayOfWeek = dayOfWeeks[date.getDay()];

    return dayOfWeek + '. ' + formatDateToShortMonthName(date);
}
export function createShortDayOfWeek() {

    var day =  i18next.t('SHORTDAYS',{ returnObjects: true});
    let days = [
        day.SUNDAY,
        day.MONDAY,
        day.TUESDAY,
        day.WEDNESDAY,
        day.THURSDAY,
        day.FRIDAY,
        day.SATURDAY,
    ];
    return days;
}

export function formatDateToShortMonthName(date) {
    var date = new Date(date);
    var day = date.getDate();
    var month = date.getMonth();
    if (day < 10) day = '0' + day;
    var months = createShortMonth();
    month = months[month];
    var dateFormatted = day + ' ' + month + ' ' + date.getFullYear();
    return dateFormatted;
}

export function checkAddressPreorder(status) {
    let isAllowed = false;
    if (!status) isAllowed = false;
    if (
        status.toLowerCase().includes(configData.network_readiness_status.AG_HOC_OUTSTANDING.toLowerCase())
        || status.toLowerCase().includes(configData.network_readiness_status.AWAITING_POP_COMPLETION.toLowerCase())
        || status.toLowerCase().includes(configData.network_readiness_status.BLOCK_FIRE_HOC_OUTSTANDING.toLowerCase())
        || status.toLowerCase().includes(configData.network_readiness_status.MDU_HOC_OUTSTANDING.toLowerCase())
        // || status.toLowerCase().includes(configData.network_readiness_status.NETWORK_READY.toLowerCase())
    ) {
        isAllowed = true;
    } 
    return isAllowed;
}

export const STEPS_REGISTER = {
    address: 'Address',
    package: 'Package',
    registration: 'Registration',
    payment: 'Payment',
    done: 'Done',
    billing_date: 'ChooseBillingDate',
    rica_verification: 'RicaVerification',
    package_confirmation: 'PackageConfirmation',
    place_order: 'PlaceOrder',
}

export const steps = [
    STEPS_REGISTER.address,
    STEPS_REGISTER.package,
    STEPS_REGISTER.registration,
    STEPS_REGISTER.payment,
    STEPS_REGISTER.done,
];

export const ADDRESSS_SOURCES = {
    vuma_core: 'VC',
    openserve: 'Openserve',
    vuma_reach: 'VR',
    octotel: 'Octotel',
    metrofibre: 'metrofibre',
}

export const PRODUCT_TYPES = {
    openserve: 'openserve',
    vuma_reach: 'vuma_reach',
    vuma_core: 'vuma_core',
    octotel: 'octotel',
    metrofibre: 'metrofibre',
}

export const PRODUCT_TYPE_CODES = {
    openserve: 'OS',
    vuma_reach: 'VR',
    vuma_core: 'VC',
    octotel: 'OC',
    metrofibre: 'MF',
}